import styled from "@emotion/styled";
import {
  ArrowRight,
  Divider,
  Select,
  Text,
  TextField,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledContainer = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const StyledTitle = styled(Text)`
  padding: 24px 0px 24px 34px;
`;

export const StyledAccessListControls = styled("div")`
  padding-inline: 34px;
`;

export const StyledDivider = styled(Divider)``;

export const StyledIconArrowRight = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.primary[500],
  width: "26px",
  height: "auto",
}));

export const StyledCellDiv = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

export const StyledCellText = styled(Text)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  color: theme.palette.grey[900],
}));

export const StyledSearchFieldContainer = styled("div")`
  display: flex;
  align-items: center;
  gap: 24px;
  padding-block: 14px;
`;

export const StyledSearchFieldWrapper = styled("div")`
  width: 60%;
  min-width: 200px;
`;

export const StyledSearchField = styled(TextField)`
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 50px 50px 0px 50px;
  *.MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.grey[200]};
    border-radius: 50px 50px 0px 50px;
    border-width: 1;
  }
  &:focus {
    /* Styles for the focused input field */
    /* Add your styles for the selected input field here */
    border-color: #007bff; /* Example: change border color when focused */
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); /* Example: add a box shadow when focused */
  }
  .MuiOutlinedInput-root {
    padding-left: 8px;
  }
  .MuiInputAdornment-root > div {
    padding: 8px;
  }
`;

export const StyledAccessActionSelectWrapper = styled("div")`
  width: 255px;
  flex-shrink: 0;
  margin-left: auto;
`;

export const StyledAccessActionSelect = styled(Select)`
  width: 100%;
`;

export const StyledRoundedLeftContainer = styled("div")`
  padding-inline: 34px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.palette.grey[100]} 0%,
    ${({ theme }) => theme.palette.background.paper} 30%
  );
  border-top-left-radius: 40px;
`;
